;$(function() {
	if ($.fancybox)
		$.fancybox.defaults.mobile.clickSlide = 'close';
});